import {
  HttpContextToken,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { LoadingBarService } from './loading-bar.service';

/**
 * Opt a single request out of the global loading bar. Set it on background or
 * frequently-polled calls that shouldn't flicker the bar:
 *
 * ```ts
 * http.get(url, { context: new HttpContext().set(SKIP_LOADING_BAR, true) });
 * ```
 */
export const SKIP_LOADING_BAR = new HttpContextToken<boolean>(() => false);

export const loadingInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  if (req.context.get(SKIP_LOADING_BAR)) {
    return next(req);
  }

  const loadingBar = inject(LoadingBarService);
  loadingBar.start();

  return next(req).pipe(finalize(() => loadingBar.complete()));
};
